<template>
  <div>
    <div v-if="uiStateStore.loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>
    <div :class="{ 'nav-open': $sidebar.showSidebar }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { useUIStateStore } from "@/stores";

export default {
  name: "App",

  setup() {
    const uiStateStore = useUIStateStore();

    return { uiStateStore };
  },
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .list-move {
    transition:
      transform 0.3s,
      opacity 0.4s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active {
    transition:
      transform 0.2s ease-in,
      opacity 0.4s ease-in;
  }

  .list-leave-active {
    transition:
      transform 1s ease-out,
      opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}

html {
  font-size: 13px;
}

#loader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  color: #464646;
  font-size: 5em;
}
</style>
